import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Theme from 'components/common/Theme/Theme'
import { BazaarVoiceReviews, BazaarVoiceReviewsSummary } from 'components/BazaarVoice'

const BOTTireLineReviewsCartridge = ({
  productId,
  reviewsCount
}) => reviewsCount ?
  <StyledBazaarVoiceReviews productId={ productId } /> :
  <StyledBazaarVoiceReviewsSummary productId={ productId } reviewsHeading />

BOTTireLineReviewsCartridge.propTypes = {
  productId: PropTypes.string,
  reviewsCount: PropTypes.number
}

BOTTireLineReviewsCartridge.type = 'BOTTireLineReviewsCartridge'

export default BOTTireLineReviewsCartridge

const StyledBazaarVoiceReviews = styled(BazaarVoiceReviews)`
  padding-top: 20px;

  .bv-cv2-cleanslate .bv-core-container-90 {
    .bv-rating-stars-off {
      color: ${Theme.colors.medium_grey_ui} !important;
    }

    .bv-content-secondary-ratings-container,
    .bv-secondary-rating-summary-bars-container .bv-secondary-rating-summary-bars {
      background-color: ${Theme.colors.medium_grey_ui} !important;
    }
  }
`

const StyledBazaarVoiceReviewsSummary = styled(BazaarVoiceReviewsSummary)`
  padding-top: 20px;
`
